import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SpreadsheetExportNotificationCardModel } from '../spreadsheet-export-notification-card.model';
import { JobNotificationCardComponent } from '../../job-notification-card.component';
import { PrintActionButtonsComponent } from '../../../../action-buttons/print-action-buttons/print-action-buttons.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-spreadsheet-export-xlsx-notification-card',
  styleUrls: ['./spreadsheet-export-xlsx-notification-card.component.scss'],
  templateUrl: './spreadsheet-export-xlsx-notification-card.component.html',
  imports: [JobNotificationCardComponent, PrintActionButtonsComponent],
})
export class SpreadsheetExportXlsxNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public downloadSpreadsheetButtonEvent = new EventEmitter<void>();
  @Input() public spreadsheetExportNotificationCard: SpreadsheetExportNotificationCardModel;

  public downloadSpreadsheetButtonClickedHandler(): void {
    this.downloadSpreadsheetButtonEvent.emit();
  }

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }
}
